import React from "react";
import { MultiSelect } from "../../../generic/elements/multiselect/MultiSelect";

const rolesOptions = [
  {
    label: "Volunteer Coordinator",
    value: "1",
  },
  {
    label: "Volunteer",
    value: "2",
  },
];
const RolesMultiSelect = ({ roles, handleSelect, errors }) => {
  return (
    <>
      <MultiSelect
        options={rolesOptions}
        value={roles}
        onChange={handleSelect}
        placeholder="Select authorised roles"
        isClearable={false}
        width="100%"
      />
      {errors?.roles && (
        <div style={{ color: "#d32f2f", fontSize: 12 }}>{errors?.roles}</div>
      )}
    </>
  );
};

export default RolesMultiSelect;
